import i18n from "i18n-js"
import { isEmail } from "../../../../../validators/validator"

export const errorMessages = (values) => {
    let errors = {}
    const validateEmai = isEmail(values?.email)
    const minPassword = values?.password?.length < 8

    // EMAIL
    if(!values?.email){  errors = { ...errors, email:i18n.t("validators.required")} }
    else if (validateEmai) { errors = { ...errors, email:i18n.t("validators.invalidEmail")} }
    // PASSWORD
    if(!values?.password){  errors = { ...errors, password:i18n.t("validators.required")} }
    else if (minPassword) { errors = { ...errors, password:i18n.t("validators.min", { name: i18n.t("form.fieldPassword")?.toLowerCase(), count: 8 })} }

return errors
}